import PropTypes from 'prop-types';
import { mergeMessages } from '@edx/frontend-platform/i18n';
import { APP_I18N_INITIALIZED, subscribe } from '@edx/frontend-platform';

import messages from './i18n';
import LegacyUnitTitle from './LegacyUnitTitle';
import UnitTitle from './UnitTitle';
import TranslationsLoader from './translations-loader';
import TranslationsError from './translations-error';

subscribe(APP_I18N_INITIALIZED, () => {
  mergeMessages(messages);
});

const UnitTitlePlugin = ({
  isEnabledOutlineSidebar,
  renderUnitNavigation,
  ...props
}) => {
  if (isEnabledOutlineSidebar) {
    return <UnitTitle {...props} navigation={renderUnitNavigation(true)} />;
  }

  return <LegacyUnitTitle {...props} />;
};

UnitTitlePlugin.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  isEnabledOutlineSidebar: PropTypes.bool.isRequired,
  renderUnitNavigation: PropTypes.func.isRequired,
  unitId: PropTypes.string.isRequired,
  unit: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    bookmarked: PropTypes.bool.isRequired,
    bookmarkedUpdateState: PropTypes.string.isRequired,
  }).isRequired,
};

export default UnitTitlePlugin;
export { TranslationsLoader, TranslationsError };
